var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container page-content"},[_c('div',{staticClass:"row page-content__heading"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(_vm._s(_vm.$t('contact.heading')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('contact.content'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }